import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * PrintIdeas permanent retail price component — GMC hard republish.
 * No compare-at, no percentage-off, no invented MSRP.
 */
class ProductPrice extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    const picker = this.closest('product-information')?.querySelector('variant-picker');
    picker?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    const picker = this.closest('product-information')?.querySelector('variant-picker');
    picker?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #formatCents(cents) {
    if (cents == null || Number.isNaN(Number(cents))) return '';
    return `$${(Number(cents) / 100).toFixed(2)}`;
  }

  #mainPriceContainer() {
    return (
      this.querySelector('[ref="priceContainer"]') ||
      this.closest('product-information')?.querySelector('.price-wrapper [ref="priceContainer"]')
    );
  }

  #updateFromVariantResource(priceContainer, resource) {
    if (!resource?.price) return false;
    const sale = this.#formatCents(resource.price);
    const currentEl =
      priceContainer.querySelector('.price-item--sale') ||
      priceContainer.querySelector('[ref="currentPrice"]') ||
      priceContainer.querySelector('.price');
    if (currentEl) {
      currentEl.textContent = sale;
      currentEl.classList.remove('price-item--sale');
      currentEl.classList.add('price-item--regular');
    }
    priceContainer.querySelectorAll(
      '.compare-at-price, s, .printideas-pdp-discount, .printideas-card-sale-percent, .printideas-card-sale-original'
    ).forEach((el) => el.remove());
    return true;
  }

  #handleProductSelect = async (event) => {
    const resource = event?.detail?.resource || event?.detail?.variant || event?.detail;
    const priceContainer = this.#mainPriceContainer();
    if (priceContainer && resource) {
      this.#updateFromVariantResource(priceContainer, {
        price: resource.price ?? resource.price_cents ?? resource.priceCents,
      });
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
